import React from 'react';
import {connect} from 'react-redux';
import {resolveAlias} from "state/selectors/data";

import Form from "containers/Form";

const mapStateToProps = (store, props) => {
    return {
        id: resolveAlias(store, 'console.presets', '@websitePreset')
    }
};

const mapDispatchToProps = {};

class ThemePresetContainer extends React.PureComponent {

    render() {
        const { id } = this.props;
        return (<div className={'pad-sm'}>
            <Form type={'console.presets'} id={id} />
        </div>);
    }

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ThemePresetContainer);